/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_With_ProviderInputs */

const en_auth_signup_with_provider = /** @type {(inputs: Auth_Signup_With_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up`)
};

const es_auth_signup_with_provider = /** @type {(inputs: Auth_Signup_With_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrarse con`)
};

/**
* | output |
* | --- |
* | "Sign up" |
*
* @param {Auth_Signup_With_ProviderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_signup_with_provider = /** @type {((inputs?: Auth_Signup_With_ProviderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_With_ProviderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_signup_with_provider(inputs)
	return en_auth_signup_with_provider(inputs)
});